import React, { InputHTMLAttributes } from 'react';

import styles from '../Fields.module.css';

function TimeField({
  className = '',
  ref,
  ...fieldProps
}: InputHTMLAttributes<HTMLInputElement> & { ref?: React.Ref<HTMLInputElement> }) {
  return (
    <input
      type='time'
      pattern='[0-9]{2}:[0-9]{2}'
      placeholder='__:__'
      ref={ref}
      className={`${styles.inputField} ${styles.timeField} ${className}`}
      id={fieldProps?.name && !fieldProps?.id ? fieldProps?.name : fieldProps?.id}
      name={fieldProps?.id && !fieldProps?.name ? fieldProps?.id : fieldProps?.name}
      {...fieldProps}
      onFocus={(event) => {
        event.target.select();
        if (fieldProps?.onFocus) fieldProps.onFocus(event);
      }}
      onChange={(event) => {
        let timeValue = event.target.value;
        if (new RegExp(/\d{4}/g).exec(timeValue)?.length) {
          timeValue = timeValue.replace(timeValue.charAt(1), `${timeValue.charAt(1)}:`);
          event.currentTarget.value = timeValue;
          event.target.value = timeValue;
        }
        if (fieldProps?.onChange)
          fieldProps.onChange({
            ...event,
            target: { ...event.target, value: timeValue },
          });
      }}
    />
  );
}
export default TimeField;
